import { Injectable } from '@angular/core';
import { ROOT_SCOPE_VARIABLES } from '@core/settings/root-scope.settings';
import { RootScopeService } from './upgraded-providers/wrappers/root-scope.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  _rootScope: any = {};

  constructor(private _rootScopeService: RootScopeService) {
    this._rootScopeService.detectScopeChanges(ROOT_SCOPE_VARIABLES.PERMISSIONS.PERMISSIONS_SET);
    //subscribe to rootScopeSubject to detect desired changes
    this._rootScopeService.rootScopeObservable
      .subscribe(() => {
        this._rootScope = this._rootScopeService.getRootScope();
      });
  }

  isPermissionEnabled(permissionKey: string) {
    return this._rootScope.isIn(permissionKey);
  }

  isRoleEnabled(roleKey: string) {
    return this._rootScope.isInRole(roleKey);
  }
}
